/* KITŌ pet : interactions du thème. Pas de dépendance. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  const money = (cents) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(cents / 100);
  const vt = (fn) => (document.startViewTransition && !reduce ? document.startViewTransition(fn) : fn());

  /* ---------- en-tête ---------- */
  const header = $('[data-header]');
  const onScrollHeader = () => header && header.classList.toggle('is-stuck', scrollY > 8);
  addEventListener('scroll', onScrollHeader, { passive: true });
  onScrollHeader();

  const burger = $('[data-burger]');
  const nav = $('[data-nav]');
  if (burger && nav) {
    burger.addEventListener('click', () => {
      const open = burger.getAttribute('aria-expanded') !== 'true';
      burger.setAttribute('aria-expanded', open);
      nav.classList.toggle('is-open', open);
    });
    const close = () => { burger.setAttribute('aria-expanded', 'false'); nav.classList.remove('is-open'); };
    nav.addEventListener('click', (e) => { if (e.target.closest('a')) close(); });
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && nav.classList.contains('is-open')) { close(); burger.focus(); } });
  }

  /* ---------- sélecteurs segmentés (pastille qui glisse) ---------- */
  function placePill(seg) {
    const on = $('button[aria-pressed="true"]', seg);
    const pill = $('.seg__pill', seg);
    if (!on || !pill) return;
    pill.style.width = on.offsetWidth + 'px';
    pill.style.translate = on.offsetLeft + 'px 0';
  }
  function pressIn(seg, btn) {
    $$('button', seg).forEach((b) => b.setAttribute('aria-pressed', b === btn));
    placePill(seg);
  }
  const placeAll = () => $$('[data-seg]').forEach(placePill);
  addEventListener('resize', placeAll);
  if ('ResizeObserver' in window) { const ro = new ResizeObserver(placeAll); $$('[data-seg]').forEach((s) => ro.observe(s)); }
  document.fonts && document.fonts.ready.then(placeAll);
  placeAll();

  /* ---------- curseurs : remplissage de la piste ---------- */
  function paintRange(input) {
    const pct = ((input.value - input.min) / (input.max - input.min)) * 100;
    input.closest('[data-range]').style.setProperty('--pct', pct + '%');
  }

  /* ---------- arche qui s'ouvre au scroll ---------- */
  const openings = $$('[data-opening]');
  if (openings.length && !reduce) {
    let ticking = false;
    const update = () => {
      ticking = false;
      openings.forEach((el) => {
        const r = el.getBoundingClientRect();
        const total = el.offsetHeight - innerHeight;
        const p = clamp(-r.top / (total || 1), 0, 1);
        el.style.setProperty('--p', clamp(p / 0.72, 0, 1).toFixed(4));
      });
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    addEventListener('resize', update);
    update();
  }

  /* ---------- ce que ça économise ---------- */
  $$('[data-save]').forEach((root) => {
    const one = +root.dataset.one, sub = +root.dataset.sub, duo = +root.dataset.duo;
    const euros = (c) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency, maximumFractionDigits: 0 }).format(c / 100);
    const nice = (c) => (c % 100 === 0 ? euros(c) : money(c));
    const set = (sel, txt) => $$(sel, root).forEach((el) => { el.textContent = txt; });
    function show(size) {
      // tout en prix par mois et par jour : un total à l'année fait peur pour le même prix
      const big = size === 'big';
      const a = big ? one * 2 : one;
      const b = big ? duo : sub;
      const gain = Math.max(0, a - b);
      const free = Math.floor(gain * 12 / b);
      set('[data-save-month]', nice(gain));
      set('[data-save-year]', nice(gain * 12));
      set('[data-save-free]', `${free} mois`);
      set('[data-save-pct]', `−${Math.round(gain / a * 100)} %`);
      set('[data-save-day]', money(Math.round(b * 12 / 365)));
      set('[data-save-v="one"]', money(a));
      set('[data-save-v="sub"]', money(b));
      set('[data-save-one-label]', big ? 'Prix des 2 flacons' : 'Prix du flacon');
      set('[data-save-note]', big ? 'Pour un grand chien.' : "Moins d'un euro.");
      $$('.yr__months li', root).forEach((li, k) => { li.classList.toggle('is-free', k >= 12 - free); });
      $$('[data-save-img]', root).forEach((im) => { im.classList.toggle('is-on', im.dataset.saveImg === size); });
    }
    $$('[data-save-size]', root).forEach((btn) => btn.addEventListener('click', () => {
      pressIn(btn.closest('[data-seg]'), btn);
      show(btn.dataset.saveSize);
    }));
    show('small');
    // les 30 matins se remplissent quand on arrive dessus
    new IntersectionObserver(([e], io) => { if (e.isIntersecting) { root.classList.add('is-in'); io.disconnect(); } }, { threshold: 0.25 }).observe(root);
  });

  /* ---------- tactile : un petit retour au doigt ---------- */
  const buzz = (ms = 8) => { try { if (navigator.userActivation?.hasBeenActive) navigator.vibrate?.(ms); } catch (e) {} };
  document.addEventListener('click', (e) => {
    if (e.target.closest('.seg button, .plan, [data-dose-add], .qa summary')) buzz();
  });

  /* ---------- cookies : rouvrir la bannière de consentement Shopify ---------- */
  const cookieBtn = $('[data-cookie-prefs]');
  if (cookieBtn) {
    const ready = () => window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
    const reveal = () => { if (ready()) cookieBtn.hidden = false; };
    reveal();
    addEventListener('load', reveal);
    cookieBtn.addEventListener('click', () => ready() && window.privacyBanner.showPreferences());
  }

  /* ---------- âge en années humaines ---------- */
  const AGE = {
    chat: {
      max: 20, def: 11, per: 4,
      stages: [
        { to: 6, name: 'Adulte', tip: 'Le bon moment pour apprendre « son normal » : son poids, sa soif, son appétit.', vet: 'Un bilan vétérinaire par an.' },
        { to: 10, name: 'Mature', tip: 'Les changements commencent, souvent sans bruit. Pesez-le une fois par mois et notez s’il boit plus.', vet: 'Un bilan au moins une fois par an. Demandez si une prise de sang est utile.' },
        { to: 14, name: 'Senior', tip: 'Les changements arrivent sans bruit. Un chat qui boit plus ou mange moins, ça se signale à votre vétérinaire.', vet: 'Un bilan tous les 6 mois est souvent conseillé.' },
        { to: 99, name: 'Grand âge', tip: 'Le confort d’abord : un couchage chaud et facile d’accès, de l’eau à plusieurs endroits.', vet: 'Un suivi rapproché, au rythme que propose votre vétérinaire.' }
      ],
      note: () => ['Dès 7 ans', 'un bilan vétérinaire au moins une fois par an.']
    },
    chien: {
      max: 18, def: 9,
      sizes: { petit: { per: 4, cuts: [7, 10, 13] }, grand: { per: 5, cuts: [5, 8, 11] } },
      stages: [
        { name: 'Adulte', tip: 'Le bon moment pour apprendre « son normal » : son poids, son énergie en promenade, ses dents.', vet: 'Un bilan vétérinaire par an.' },
        { name: 'Mature', tip: 'Il ralentit parfois sans qu’on le voie. Notez s’il hésite à sauter ou à monter les escaliers.', vet: 'Un bilan au moins une fois par an.' },
        { name: 'Senior', tip: 'Articulations, dents, poids : adaptez les promenades à sa forme, plus courtes et plus souvent.', vet: 'Un bilan tous les 6 mois est souvent conseillé.' },
        { name: 'Grand âge', tip: 'Le confort d’abord : un couchage moelleux, un sol qui ne glisse pas, de l’eau à portée.', vet: 'Un suivi rapproché, au rythme que propose votre vétérinaire.' }
      ],
      note: () => ['Après 7 ans', 'un bilan par an, plus souvent avec l’âge.']
    }
  };

  const humanAge = (species, a, big) => {
    if (a <= 1) return 15;
    const per = species === 'chat' ? AGE.chat.per : AGE.chien.sizes[big ? 'grand' : 'petit'].per;
    return 24 + (a - 2) * per;
  };
  const stageOf = (species, a, big) => {
    if (species === 'chat') return AGE.chat.stages.find((s) => a <= s.to);
    const c = AGE.chien.sizes[big ? 'grand' : 'petit'].cuts;
    return AGE.chien.stages[a < c[0] ? 0 : a < c[1] ? 1 : a < c[2] ? 2 : 3];
  };

  $$('[data-age]').forEach((root) => {
    const input = $('[data-age-input]', root);
    const out = $('[data-age-out]', root);
    const big = $('[data-age-human]', root);
    const sentence = $('[data-age-sentence]', root);
    const stageEl = $('[data-age-stage]', root);
    const tipEl = $('[data-age-tip]', root);
    const vetEl = $('[data-age-vet]', root);
    const noteEl = $('[data-age-note]', root);
    const sizeSeg = $('[data-size-seg]', root);
    const imgCat = $('.kp-age-chat', root);
    const imgDog = $('.kp-age-chien', root);
    let species = 'chat', size = 'petit';

    const showImg = () => {
      if (imgCat) imgCat.classList.toggle('is-off', species !== 'chat');
      if (imgDog) imgDog.classList.toggle('is-off', species !== 'chien');
    };

    function render() {
      const a = +input.value;
      let human, st;
      if (species === 'chat') {
        human = a === 1 ? 15 : 24 + (a - 2) * AGE.chat.per;
        st = AGE.chat.stages.find((s) => a <= s.to);
      } else {
        const z = AGE.chien.sizes[size];
        human = a === 1 ? 15 : 24 + (a - 2) * z.per;
        const i = a < z.cuts[0] ? 0 : a < z.cuts[1] ? 1 : a < z.cuts[2] ? 2 : 3;
        st = AGE.chien.stages[i];
      }
      if (a === 1) human = 15;
      out.textContent = a + (a > 1 ? ' ans' : ' an');
      big.style.setProperty('--num', human);
      big.setAttribute('aria-label', human + ' ans en âge humain');
      sentence.innerHTML = `Un ${species} de ${a} an${a > 1 ? 's' : ''}, c’est comme <b>un humain de ${human} ans</b>. Repère approximatif.`;
      stageEl.textContent = st.name;
      tipEl.textContent = st.tip;
      vetEl.textContent = st.vet;
      const [b, t] = AGE[species].note(a);
      noteEl.innerHTML = `<b>${b}</b>${t}`;
      paintRange(input);
    }

    input.addEventListener('input', render);
    $$('[data-species]', root).forEach((btn) => btn.addEventListener('click', () => {
      if (btn.dataset.species === species) return;
      vt(() => {
        species = btn.dataset.species;
        pressIn(btn.closest('[data-seg]'), btn);
        sizeSeg.hidden = species !== 'chien';
        input.max = AGE[species].max;
        if (+input.value > input.max) input.value = input.max;
        showImg();
        render();
      });
      requestAnimationFrame(() => placePill(sizeSeg));
    }));
    $$('[data-size]', root).forEach((btn) => btn.addEventListener('click', () => {
      size = btn.dataset.size;
      pressIn(sizeSeg, btn);
      render();
    }));
    if (!document.startViewTransition) document.documentElement.classList.add('no-vt');
    showImg();
    render();
  });

  /* ---------- dose → formule → panier ---------- */
  $$('[data-dose]').forEach((root) => {
    const dataEl = $('[data-dose-data]', root);
    if (!dataEl) return;
    const data = JSON.parse(dataEl.textContent);
    const weight = $('[data-weight]', root);
    const wOut = $('[data-weight-out]', root);
    const nameIn = $('[data-dose-name]', root);
    const summary = $('[data-dose-summary]', root);
    const viz = $('[data-dose-viz]', root);
    const mlEl = $('[data-dose-ml]', root);
    const addBtn = $('[data-dose-add]', root);
    const addLabel = $('[data-dose-add-label]', root);
    const err = $('[data-dose-error]', root);
    const radios = $$('input[type="radio"]', root);
    const subRow = $('[data-plan-row="sub"]', root);
    const ageIn = $('[data-dose-age]', root), ageOut = $('[data-age-out]', root);
    const card = $('[data-card]', root);
    const rc = (k) => $(`[data-rc-${k}]`, root);
    const dateFr = (d) => d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });
    let species = 'chat', lastBig = null;

    if (!data.hasPlan && subRow) {
      subRow.hidden = true;
      radios.find((r) => r.value === 'one').checked = true;
    }

    const LIMITS = { chat: { max: 12, def: 4 }, chien: { max: 45, def: 9 } };
    const fmtKg = (v) => String(v).replace('.', ',') + ' kg';

    function render() {
      const kg = +weight.value;
      const big = kg > 10;
      const tier = big ? data.big : data.small;
      const name = (nameIn.value || '').trim();
      const who = name ? name.replace(/[<>&"]/g, '') : 'lui';
      wOut.textContent = fmtKg(kg);
      summary.innerHTML = big
        ? `Pour ${who}, <em>2 ml par jour</em>. Il faut deux flacons par mois : c’est le duo.`
        : `Pour ${who}, <em>1 ml par jour</em>. Un flacon dure un mois.`;
      $('[data-plan-name="sub"]', root).textContent = big ? 'Abonnement duo, 2 flacons' : 'Abonnement mensuel';
      $('[data-plan-desc="one"]', root).textContent = big ? 'Deux flacons, une seule fois. Sans engagement.' : 'Un flacon, une seule fois. Sans engagement.';
      ['sub', 'one'].forEach((k) => {
        $(`[data-price="${k}"]`, root).textContent = money(tier[k].price);
        $(`[data-perday="${k}"]`, root).textContent = (k === 'sub' ? 'par mois, ' : '') + 'soit ' + money(Math.round(tier[k].price * 12 / 365)) + ' par jour';
      });
      if (mlEl) mlEl.textContent = big ? '2 × 1 ml' : '1 ml';
      if (card && ageIn) {
        const a = +ageIn.value;
        const dogBig = species === 'chien' && big;
        ageOut.textContent = a + (a > 1 ? ' ans' : ' an');
        paintRange(ageIn);
        const end = new Date(Date.now() + 30 * 864e5);
        rc('name').textContent = name ? who : (species === 'chat' ? 'votre chat' : 'votre chien');
        rc('dose').textContent = big ? '2 ml par jour' : '1 ml par jour';
        rc('age').textContent = 'comme ' + humanAge(species, a, dogBig) + ' ans';
        rc('end').textContent = dateFr(end);
        rc('day').textContent = money(Math.round(tier.sub.price * 12 / 365));
        const days = a * 365, step = days >= 1000 ? 100 : 10;
        rc('days').textContent = (a > 1 ? 'Environ ' : 'Déjà ') + (Math.round(days / step) * step).toLocaleString('fr-FR');
        const st = stageOf(species, a, dogBig);
        rc('tip').textContent = st.vet + ' ' + st.tip;
        card.dataset.vetMonths = st.name === 'Senior' || st.name === 'Grand âge' ? 6 : 12;
        card.classList.remove('is-pulse'); void card.offsetWidth; card.classList.add('is-pulse');
      }
      if (viz && lastBig !== null && lastBig !== big && !reduce) {
        viz.classList.remove('drip'); void viz.offsetWidth; viz.classList.add('drip');
      }
      lastBig = big;
      paintRange(weight);
      const safe = name.slice(0, 14);
      addLabel.textContent = safe ? 'Commencer le rituel de ' + safe : 'Commencer son rituel';
      $$('[data-cta-name]').forEach((a) => {
        if (!a.dataset.ctaBase) a.dataset.ctaBase = a.textContent;
        a.textContent = safe ? a.dataset.ctaName.replace('{n}', safe) : a.dataset.ctaBase;
      });
    }

    $$('[data-species]', root).forEach((btn) => btn.addEventListener('click', () => {
      species = btn.dataset.species;
      pressIn(btn.closest('[data-seg]'), btn);
      weight.max = LIMITS[species].max;
      weight.value = LIMITS[species].def;
      if (ageIn) { ageIn.max = AGE[species].max; if (+ageIn.value > +ageIn.max) ageIn.value = ageIn.max; }
      render();
    }));
    weight.addEventListener('input', render);
    nameIn.addEventListener('input', render);
    if (ageIn) ageIn.addEventListener('input', render);

    // rappel agenda (.ics) : généré dans le navigateur, rien n'est envoyé
    const ics = $('[data-rc-ics]', root);
    if (ics) ics.addEventListener('click', () => {
      const months = +card.dataset.vetMonths || 12;
      const d = new Date(); d.setMonth(d.getMonth() + months);
      const day = d.toISOString().slice(0, 10).replace(/-/g, '');
      const who = (nameIn.value || '').trim().replace(/[\r\n,;]/g, '') || (species === 'chat' ? 'mon chat' : 'mon chien');
      const body = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//KITO pet//Rituel//FR', 'BEGIN:VEVENT',
        'UID:' + Date.now() + '@kitopet', 'DTSTAMP:' + new Date().toISOString().replace(/[-:]/g, '').slice(0, 15) + 'Z',
        'DTSTART;VALUE=DATE:' + day, 'SUMMARY:Bilan vétérinaire de ' + who,
        'DESCRIPTION:Prendre rendez-vous chez le vétérinaire. Noter avant : sa soif\, son appétit\, son poids.',
        'BEGIN:VALARM', 'TRIGGER:-P7D', 'ACTION:DISPLAY', 'DESCRIPTION:Bilan vétérinaire dans 7 jours', 'END:VALARM',
        'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
      const a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([body], { type: 'text/calendar' }));
      a.download = 'rappel-bilan-veterinaire.ics';
      a.click();
      setTimeout(() => URL.revokeObjectURL(a.href), 2000);
      buzz(12);
    });

    // la pipette se remplit quand la section arrive à l'écran
    if (viz) {
      const svg = $('svg', viz);
      svg.style.setProperty('--level', reduce ? .667 : 0);
      new IntersectionObserver(([e], o) => {
        if (e.isIntersecting) { svg.style.setProperty('--level', .667); o.disconnect(); }
      }, { threshold: 0.4 }).observe(viz);
    }

    addBtn.addEventListener('click', async () => {
      err.hidden = true;
      const tier = +weight.value > 10 ? data.big : data.small;
      const mode = radios.find((r) => r.checked).value;
      const line = tier[mode];
      if (!data.product || !line.id) { location.href = data.url; return; }
      if (!line.available) { err.textContent = 'Cette formule est épuisée pour le moment.'; err.hidden = false; return; }
      const item = { id: line.id, quantity: line.qty };
      if (mode === 'sub' && line.plan) item.selling_plan = line.plan;
      if (nameIn.value.trim()) item.properties = { 'Prénom': nameIn.value.trim().slice(0, 14) };
      addBtn.disabled = true;
      const prev = addLabel.textContent;
      addLabel.textContent = 'Ajout…';
      try {
        const r = await fetch(KP.routes.cartAdd + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
        const j = await r.json();
        if (!r.ok) throw new Error(j.description || j.message || 'Erreur');
        addLabel.textContent = 'Ajouté';
        await Cart.open();
      } catch (e) {
        err.textContent = e.message;
        err.hidden = false;
      } finally {
        setTimeout(() => { addLabel.textContent = prev; addBtn.disabled = false; }, 900);
      }
    });

    render();
  });

  /* ---------- panier (tiroir <dialog>) ---------- */
  const Cart = (() => {
    const dlg = $('#CartDrawer');
    if (!dlg) return { open: async () => { location.href = KP.routes.cart; } };
    const lines = $('[data-cart-lines]', dlg);
    const foot = $('[data-cart-foot]', dlg);
    const total = $('[data-cart-total]', dlg);
    const i18n = JSON.parse($('[data-cart-i18n]', dlg).textContent);
    const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    function setCount(n) {
      $$('[data-cart-count]').forEach((el) => {
        if (el.textContent !== String(n)) { el.textContent = n; el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
      });
    }

    function draw(cart) {
      setCount(cart.item_count);
      if (!cart.item_count) {
        lines.innerHTML = $('#CartEmpty').innerHTML;
        foot.hidden = true;
        return;
      }
      foot.hidden = false;
      total.textContent = money(cart.total_price);
      lines.innerHTML = cart.items.map((it) => {
        const img = it.image ? `<img src="${esc(it.image)}${it.image.includes('?') ? '&' : '?'}width=180" alt="" width="72" height="72" loading="lazy">` : '<span></span>';
        const meta = [it.variant_title && !/default/i.test(it.variant_title) ? it.variant_title : '', it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.name : '', it.properties && it.properties['Prénom'] ? 'Pour ' + it.properties['Prénom'] : '']
          .filter(Boolean).map(esc).join('<br>');
        return `<div class="line" data-key="${esc(it.key)}">
          ${img}
          <div>
            <div class="line__t">${esc(it.product_title)}</div>
            ${meta ? `<div class="line__m">${meta}</div>` : ''}
            <div class="line__q">
              <button type="button" data-q="${it.quantity - 1}" aria-label="Retirer un">−</button>
              <span>${it.quantity}</span>
              <button type="button" data-q="${it.quantity + 1}" aria-label="Ajouter un">+</button>
            </div>
          </div>
          <span class="line__p">${money(it.final_line_price)}</span>
        </div>`;
      }).join('');
    }

    async function refresh() {
      try {
        const r = await fetch(KP.routes.cart + '.js', { headers: { Accept: 'application/json' } });
        if (r.ok) draw(await r.json());
      } catch (e) {}
    }

    async function open() {
      if (!dlg.open) dlg.showModal();
      await refresh();
    }

    lines.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-q]');
      if (!b) return;
      const key = b.closest('[data-key]').dataset.key;
      dlg.classList.add('is-busy');
      try {
        const r = await fetch(KP.routes.cartChange + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: Math.max(0, +b.dataset.q) })
        });
        if (!r.ok) throw new Error();
        draw(await r.json());
      } catch (_) {
        lines.insertAdjacentHTML('afterbegin', `<p class="dose__error">${esc(i18n.error)}</p>`);
      } finally {
        dlg.classList.remove('is-busy');
      }
    });

    dlg.addEventListener('click', (e) => {
      if (e.target === dlg || e.target.closest('[data-cart-close]')) dlg.close();
    });
    $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); open(); }));

    return { open, refresh };
  })();

  /* ---------- les années passent : l'étape suit le défilement ---------- */
  $$('[data-years]').forEach((sec) => {
    const imgs = $$('[data-year-img]', sec), steps = $$('[data-year-step]', sec);
    if (reduce || !steps.length) return;
    let cur = 0, ticking = false;
    const update = () => {
      ticking = false;
      const r = sec.getBoundingClientRect();
      const run = r.height - innerHeight;
      const p = clamp(-r.top / Math.max(1, run), 0, 1);
      sec.style.setProperty('--p', p.toFixed(4));
      const i = Math.min(steps.length - 1, Math.floor(p * steps.length * 0.999));
      if (i !== cur) {
        steps[cur].classList.remove('is-on'); imgs[cur]?.classList.remove('is-on');
        steps[i].classList.add('is-on'); imgs[i]?.classList.add('is-on');
        cur = i;
      }
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  });

  /* ---------- films en boucle : pause hors écran, bouton pause, mouvement réduit ---------- */
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  $$('video[data-src]').forEach((v) => {
    const m = matchMedia('(max-width: 700px) and (orientation: portrait)').matches;
    if (m && v.dataset.posterM) v.poster = v.dataset.posterM;
    v.src = m && v.dataset.srcM ? v.dataset.srcM : v.dataset.src;
  });
  $$('.film video, video.loop').forEach((v) => {
    const btn = v.closest('section')?.querySelector('[data-film-pause]');
    let held = still, seen = false;
    const play = () => { if (!held && seen) v.play().catch(() => {}); };
    if (still) { v.removeAttribute('autoplay'); v.pause(); }
    if (btn) {
      btn.setAttribute('aria-pressed', String(held));
      btn.addEventListener('click', () => {
        held = !held;
        btn.setAttribute('aria-pressed', String(held));
        held ? v.pause() : play();
      });
    }
    new IntersectionObserver(([e]) => { seen = e.isIntersecting; seen ? play() : v.pause(); }).observe(v);
  });

  /* ---------- barre d'achat mobile ---------- */
  const bar = $('[data-sticky-buy]');
  const hero = $('.film') || $('.hero');
  const doseSec = $('#dose');
  if (bar && hero) {
    let heroOut = false;
    const near = new Set();
    const sync = () => {
      const on = heroOut && !near.size;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', String(!on));
      bar.inert = !on;
    };
    new IntersectionObserver(([e]) => { heroOut = !e.isIntersecting; sync(); }).observe(hero);
    const io = new IntersectionObserver((es) => { es.forEach((e) => e.isIntersecting ? near.add(e.target) : near.delete(e.target)); sync(); }, { threshold: 0.05 });
    [doseSec, $('.final'), $('.ftr')].filter(Boolean).forEach((el) => io.observe(el));
  }
  // Onglet en arrière-plan : la goutte et un cœur battent tour à tour, le titre appelle doucement
  const ico = $('link[data-kp-ico]');
  if (ico) {
    const [one, two, perk] = ico.dataset.kpIco.split(' '), title = document.title;
    // halète 3 fois, puis dresse l'oreille
    const seq = [one, two, one, two, one, two, perk, perk];
    seq.forEach((src) => { new Image().src = src; });
    let k = 0, timer = 0;
    const run = (ms) => { clearInterval(timer); if (!reduce) timer = setInterval(() => { ico.href = seq[k++ % seq.length]; }, ms); };
    run(280);
    document.addEventListener('visibilitychange', () => {
      document.title = document.hidden ? 'Il vous attend… ' + title : title;
      // un onglet caché ne tourne qu'une fois par seconde
      run(document.hidden ? 1000 : 280);
    });
  }
})();
